import React from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { PRES, TYPE } from '../chrome';
import { focusVisibleSx } from '../ui/focus';

interface AdminVisibilitySwitchProps {
  checked: boolean;
  disabled?: boolean;
  label: string;
  disabledReason?: string;
  onChange: (checked: boolean) => void;
}

const AdminVisibilitySwitch: React.FC<AdminVisibilitySwitchProps> = ({
  checked,
  disabled,
  label,
  disabledReason,
  onChange,
}) => (
  <Box>
    <FormControlLabel
      control={(
        <Switch
          checked={checked}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
          inputProps={{ 'aria-label': label }}
          sx={{ ...focusVisibleSx }}
        />
      )}
      label={<Typography sx={{ fontFamily: TYPE.ui, ...TYPE.label, color: PRES.textSecondary }}>{label}</Typography>}
    />
    {disabled && disabledReason && (
      <Typography sx={{ color: PRES.textTertiary, fontFamily: TYPE.ui, ...TYPE.caption, ml: 1.5 }}>
        {disabledReason}
      </Typography>
    )}
  </Box>
);

export default AdminVisibilitySwitch;
